<template>
  <div>
    <div v-if="step.construction_step.is_valid" class="is-border is-margin-top-xsmall">
      <div class="columns is-gapless has-bg-white is-min-height-64">
        <div class="column is-narrow  is-flex is-padding-small"
             :class="step.construction_step.is_valid ? 'has-bg-success' : 'has-bg-danger'">
          <span class="icon has-text-white is-self-centered"><i
                  :class="step.construction_step.is_valid ? 'fa-check-circle' : 'fa-exclamation-circle'"
                  class="fas fa-check-circle"></i></span>
        </div>
        <div class="column is-padding-top">
          <div class="is-padding-left is-padding-bottom">
            <span class="title is-4">{{step.construction_step.name}}
            ({{step.construction_step.progress}}%)</span>
          </div>
          <div class="columns is-gapless is-padding-left">
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Montant attendu</label>
            </div>
            <div class="column is-3 is-padding-right">
              <label for="" class="label">Montant perçu</label>
            </div>
            <div class="column">
              <label for="" class="label">Reception paiement</label>
            </div>
          </div>
          <div class="columns is-gapless is-margin-top-xsmall is-padding-left has-bg-grey-lighter is-vcentered is-min-height-50 is-border-top">
            <div class="column is-3 is-padding-right">
              <b class="is-uppercase">{{amountExpected}} {{$currency}} TTC</b>
            </div>
            <div class="column is-3 is-padding-right">
              <div class="field has-addons">
                <p class="control"
                   :class="{'is-border': !(isAdmin || isSectorManager)}"
                >
                  <v-input :id="idx + '-amount_received'"
                           :name="idx + '-amount_received'"
                           :model="step.amount_received"
                           :number="true"
                           :disabled="!(isAdmin || isSectorManager)"
                           input-type="number"
                           @input="updateStep('amount_received', $event, step)"
                           v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val"
                           data-vv-as="Fonds recus">
                  </v-input>
                </p>
                <p class="control is-inline-flex is-border has-bg-grey-lighter has-text-primary is-vcentered is-padding-left-small is-padding-right-small is-nowrap">
                  <b>{{$currency}} TTC</b>
                </p>
              </div>
            </div>
            <div class="column is-3">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr type="date" class="input"
                              :class="{'is-border': !(isAdmin || isSectorManager)}"
                              ref="amount_received_date"
                              @input="updateStep('amount_received_date', $event, step)"
                              v-model="step.amount_received_date"
                              :disabled="!(isAdmin || isSectorManager)"
                              :config="dateConfig"
                  >
                  </flat-pickr>
                </div>
              </div>
            </div>
            <div class="column has-text-right is-self-stretched">
              <button v-if="step.construction_step.is_valid && (isAdmin || isSectorManager)" :disabled="!(isAdmin || isSectorManager)" @click="getPdf"
                      data-tooltip="GÉNÉRER COURRIER"
                      class="button is-success is-small is-min-height-full is-radiusless w150p">
                <span><i class="fas fa-cogs is-margin-xsmall"></i>
                </span> <span class="is-size-7">GÉNÉRER COURRIER</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <sru-item v-for="(lre, index) in lreList" @setLre="setLre" :toOpen="toOpen" :key="index + '-' + lre.pk" :lre="lre"
                :advPk="advPk" :buyerPk="lre.buyer" :buyers="buyers" :sendingDate="sendingDate" :step="step"
                :index="index"></sru-item>
      <div v-if="canAdd" @click="addCoReco()">
        <button class="button is-grey-dark is-fullwidth is-radiusless is-min-height-50">
          <span v-if="!loadingCo">AJOUTER UN COURRIER RECOMMANDÉ CO-ACQUÉREUR</span>
          <span v-else><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span>
        </button>
      </div>
    </div>
    <div v-else class="has-bg-grey-3">
      <div style="opacity: 0.6"
           class="columns is-gapless has-bg-lighter is-min-height-50 is-margin-top-xsmall is-border">
        <div class="column is-narrow w50p has-bg-white-ter is-border-right"></div>
        <div class="column is-padding-left is-padding-top-small is-padding-bottom-small">
          <span class="is-uppercase has-text-weight-medium">{{step.construction_step.name}}
            ({{step.construction_step.progress}}%) : <b>{{amountExpected}} {{$currency}} TTC</b></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { AdvMx } from '@/mixins'
  import moment from 'moment'
  import SruItem from './SruItem'

  export default {
    name: 'AppelDeFondsItem',
    mixins: [AdvMx],
    components: { SruItem },
    data () {
      return {
        loadingCo: false,
        edit: false,
        open: false
      }
    },
    props: {
      toOpen: String,
      step: {
        type: Object,
        required: true
      },
      idx: Number,
      allLre: Array
    },
    computed: {
      amountExpected () {
        if (this.adv && this.adv.lot_sale_price && this.step && this.step.construction_step) {
          return Math.round(Number(this.adv.lot_sale_price) * Number(this.step.construction_step.progress)) / 100
        }
      },
      sendingDate () {
        return moment(this.step.sending_date).format('DD/MM/YYYY')
      },
      lreList () {
        if (this.step) {
          let result = this.allLre.filter(x => {
            return x.step_uuid === this.step.construction_step.uuid
          })
          return result
        }
        return []
      },
      canAdd () {
        return this.coBuyers.length && this.buyers.length > this.lreList.length
      },
      missingBuyer () {
        let buyersArray = this.buyersPk
        for (let lre of this.lreList) {
          if (buyersArray.includes(lre.buyer)) {
            const index = buyersArray.findIndex(x => x === lre.buyer)
            if (index >= 0) {
              buyersArray.splice(index, 1)
            }
          }
        }
        return buyersArray
      }
    },
    methods: {
      updateStep (key, value, step) {
        this.step[key] = value
        this.$emit('updateStep')
      },
      async setLre (step, buyer, lre) {
        let params = {
          step_uuid: step,
          buyer: buyer,
          lre: lre
        }
        try {
          let res = await this.$api.advService.postAdfLre(this.advPk, params)
          console.log(res.data)
        } catch (e) {
          console.log(e)
        }
      },
      async addCoReco () {
        this.loadingCo = true
        let params = {
          step_uuid: this.step.construction_step.uuid,
          buyer: this.missingBuyer[0],
          numero_ar: null,
          sending_date: null,
          ar_received_date: null
        }
        try {
          let res = await this.$api.advService.postAdfLre(this.advPk, params)
          console.log(res.data)
        } catch (e) {
          console.log(e)
        }
      },
      getPdf () {
        const apiUrl = this.$configs.APIROOT
        let params = {
          link: `${apiUrl}/adf/${this.$route.params.id}/${this.step.construction_step.uuid}`
        }
        this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
      },
      removePdf () {
      }
    }
  }
</script>
<style scoped>
  .control.has-icons-left .input {
    padding-left: 1.6em
  }

  table.is-form input, table.is-form .input {
    width: calc(100% - 10px);
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/AppelDeFondsItem.vue